export function scrollContainer(element: HTMLElement): HTMLElement | null {
  let parent = element.parentElement;
  while (parent) {
    const overflow = getComputedStyle(parent).overflowY;
    if ((overflow === 'auto' || overflow === 'scroll') && parent.scrollHeight > parent.clientHeight + 2) return parent;
    parent = parent.parentElement;
  }
  return null;
}
export function nearEnd(container: HTMLElement | null): boolean {
  if (container) return container.scrollHeight - container.scrollTop - container.clientHeight <= 200;
  return document.documentElement.scrollHeight - window.scrollY - window.innerHeight <= 200;
}
export function safeChannelActions(suggestions: Array<{ field: string; value: string }>, recorded: Array<{ label: string; value: string }>): string[] {
  const result = new Set<string>();
  for (const suggestion of suggestions) {
    if (suggestion.field !== 'contactChannels') continue;
    try {
      const entries: unknown = JSON.parse(suggestion.value);
      if (!Array.isArray(entries) || entries.length > 12) continue;
      for (const entry of entries) {
        if (!entry || typeof entry.label !== 'string' || typeof entry.value !== 'string' || entry.value.trim()) continue;
        if (!['WhatsApp', 'Instagram'].includes(entry.label)) continue;
        if (!recorded.some(item => item.label.toLowerCase() === entry.label.toLowerCase() && item.value.trim())) result.add(entry.label);
      }
    } catch { /* Never infer actions from unstructured model prose. */ }
  }
  return [...result].slice(0, 2);
}
